import { Globals } from "../CoreApp/Globals";

/**
 * @param {string} strCode
 * @param {object} [replaceDict]
 * @returns {string}
 */
export function appstr(strCode, replaceDict) {
  if (!Globals._stringMgr) return strCode;
  return Globals._stringMgr.appstr(strCode, replaceDict);
}
